module.exports = __webpack_public_path__ + "static/media/ic_deactivate_account.88f909c5.svg";